import { Component, useState } from "react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import RouteGenerator from "@/components/RouteGenerator";
import BonusChallenge from "@/components/BonusChallenge";
import SelfieWall from "@/components/SelfieWall";
import Footer from "@/components/Footer";
import JournalDrawer from "@/components/JournalDrawer";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/hooks/useLenis";
import { useJournal } from "@/hooks/useJournal";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error("EcoRoute crashed:", error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-forest-950 p-8 text-cream">
          <p className="font-display text-2xl">Something snapped a branch. Refresh to try again.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const Page = () => {
  useLenis();
  const journal = useJournal();
  const [journalOpen, setJournalOpen] = useState(false);
  return (
    <div className="min-h-screen overflow-x-clip bg-forest-950 text-cream">
      <div className="grain-overlay" />
      <Navbar
        journalCount={journal.routes.length}
        onOpenJournal={() => setJournalOpen(true)}
      />
      <main>
        <Hero />
        <Marquee />
        <RouteGenerator onSaveRoute={journal.save} isRouteSaved={journal.hasRoute} />
        <BonusChallenge />
        <SelfieWall />
      </main>
      <Footer />
      <JournalDrawer
        open={journalOpen}
        onClose={() => setJournalOpen(false)}
        routes={journal.routes}
        onRemove={journal.remove}
      />
      <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          style: {
            background: "#0E2A1E",
            border: "1px solid #2D6A4F",
            color: "#F5F2EB",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <Page />
    </ErrorBoundary>
  );
}

export default App;
